export default __webpack_public_path__ + "static/media/economics-bg-small.f818b201.webp";